<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12" sm="12" class="left--right-00">
          <div class="Schedule-block">
            <div class="Schedule-left">
              <div class="Schedule-title">Schedule Test</div>
              <v-row>
                <v-col cols="12" sm="12">
                  <div class="info-row">
                    <div class="label-data">Test Name:</div>
                    <div class="lable-input">
                      <v-text-field
                        v-model="testName"
                        dense
                        hide-details
                        :disabled="disableStartDateTime || isAitsTest || isPytTest"
                        :readonly="isAitsTest || isPytTest"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <div class="info-row">
                    <div class="label-data">Test Duration:</div>
                    <div class="lable-input">
                      {{ selectedTest.duration + " Min" }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" v-if="(data && data.selectedTest && data.selectedTest.is_online_test==1) || (data&& data.selectedTest && !data.selectedTest.is_online_test && data.selectedTest.omr_pattern_id) ">
                  <div class="info-row">
                    <div class="label-data">{{data&& data.selectedTest && !data.selectedTest.is_online_test && data.selectedTest.omr_pattern_id?"Test ID:":"Shuffle Questions:"}}</div>
                    <div class="lable-input shuffle-question-pattern">
                      <!-- <v-checkbox :disabled="disableStartDateTime" id="shuffle" v-model="shuffle"></v-checkbox> -->
                      <span v-if="data&& data.selectedTest && !data.selectedTest.is_online_test && data.selectedTest.omr_pattern_id">
                        {{ data&& data.selectedTest.id }}
                      </span>
                      <v-icon 
                      v-else-if="data && data.selectedTest && data.selectedTest.is_online_test == 1"
                        @click="shuffle = !shuffle"
                        :title="shuffle ? 'Turn Shuffle Off' : 'Turn Suffle On'"
                        :class="[
                          shuffle ? 'shuffle-green' : 'shuffle-gray',
                          disableStartDateTime ? 'disable-shuffle' : '',
                        ]"
                        >mdi-shuffle-variant</v-icon
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" v-if="isLongTimeTest" class="pt-0 pb-0">
                  <div class="info-row">
                    <div class="label-data">Long Term Test</div>
                    <div class="lable-input ">
                     <v-checkbox  v-model="longTimeTest" :disabled="disableStartDateTime" @click="longTermTestWarning()"></v-checkbox> 
                      
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="12"  class="pt-0 pb-0">
                  <div class="info-row">
                    <div class="label-data">Auto-submit on 3 Tab Changes: </div>
                    <div class="lable-input ">
                     <v-checkbox  v-model="tabChange" :disabled="disableStartDateTime" @click="longTermTestWarning()"></v-checkbox> 
                      
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" class="pt-0 pb-0">
                  <div class="info-row">
                    <div class="label-data">Start Date & Time:</div>
                    <div class="lable-input date-pick">
                      <v-menu
                        :disabled="disableStartDateTime"
                        ref="startDateMenu"
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :return-value.sync="startDate"
                        transition="scale-transition"
                        offset-y
                        min-width="130px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="computedDateFormattedMomentjs(startDate)"
                            label="Date"
                            append-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-tooltip v-if="allowed" bottom></v-tooltip>
                        <v-date-picker
                          v-model="startDate"
                          @input="$refs.startDateMenu.save(startDate)"
                          :allowed-dates="allowedDates"
                          :max="allowed_end_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-alert dense outlined type="info"
                            >Subscription-expiry:{{ allowed_end_date }}</v-alert
                          >

                          <!-- <v-spacer></v-spacer> -->
                          <!-- <v-btn text color="primary" @click="startDateMenu = false">Cancel</v-btn> -->
                          <!-- <v-btn text color="primary" @click="$refs.startDateMenu.save(startDate)">OK</v-btn> -->
                        </v-date-picker>
                      </v-menu>
                    </div>
                    <div class="hr-min-block">
                      <v-menu
                        :disabled="disableStartDateTime"
                        ref="startTimeMenu"
                        v-model="startTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="startTime"
                        transition="scale-transition"
                        offset-y
                        min-width="250px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="startTime"
                            label="Time"
                            append-icon="access_time"
                            readonly
                            v-on="on"
                          >
                          </v-text-field>
                        </template>
                        <v-time-picker
                          v-if="startTimeMenu"
                          v-model="startTime"
                          @click:minute="$refs.startTimeMenu.save(startTime)"
                          full-width
                          format="24hr"
                        >
                        </v-time-picker>
                      </v-menu>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" class="pt-0 pb-0">
                  <div class="info-row">
                    <div class="label-data">{{data&& data.selectedTest && !data.selectedTest.is_online_test && data.selectedTest.omr_pattern_id?"Result Announcement:":"End Date & Time:"}}</div>
                    <div class="lable-input date-pick">
                      <v-menu
                        ref="endDateMenu"
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :return-value.sync="endDate"
                        transition="scale-transition"
                        offset-y
                        min-width="130px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="computedDateFormattedMomentjs(endDate)"
                            label="Date"
                            append-icon="event"
                            readonly
                            v-on="on"
                          >
                          </v-text-field>
                        </template>

                        <v-date-picker
                          @input="$refs.endDateMenu.save(endDate)"
                          v-model="endDate"
                          :allowed-dates="allowedDates"
                          :max="allowed_end_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-alert dense outlined type="info"
                            >Subscription-expiry:{{ allowed_end_date }}</v-alert
                          >
                          <!-- <v-spacer></v-spacer> -->
                          <!-- <v-btn text color="primary" @click="endDateMenu = false">Cancel</v-btn> -->
                          <!-- <v-btn text color="primary" @click="$refs.endDateMenu.save(endDate)">OK</v-btn> -->
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <div class="hr-min-block">
                      <v-menu
                        ref="endTimeMenu"
                        v-model="endTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="endTime"
                        transition="scale-transition"
                        offset-y
                        min-width="250px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="endTime"
                            label="Time"
                            append-icon="access_time"
                            readonly
                            v-on="on"
                          >
                          </v-text-field>
                        </template>
                        <v-time-picker
                          v-if="endTimeMenu"
                          v-model="endTime"
                          @click:minute="$refs.endTimeMenu.save(endTime)"
                          full-width
                          format="24hr"
                        >
                          <!-- <v-spacer></v-spacer> -->
                          <!-- <v-btn text color="primary" @click="endTimeMenu = false">Cancel</v-btn> -->
                          <!-- <v-btn text color="primary" @click="$refs.endTimeMenu.save(endTime)">OK</v-btn> -->
                        </v-time-picker>
                      </v-menu>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="Schedule-right" v-if="user.role_id !== roleIds.PA">
              <div class="Schedule-title" v-if="!(data&& data.selectedTest && !data.selectedTest.is_online_test && data.selectedTest.omr_pattern_id)">Solution to be Visible on:</div>
              <v-row v-if="!(data&& data.selectedTest && !data.selectedTest.is_online_test && data.selectedTest.omr_pattern_id)">
                <v-col cols="12" sm="12">
                  <v-radio-group
                    :disabled="isRescheduling"
                    v-model="mode"
                    row
                    class="cust-radio-row"
                  >
                    <v-radio
                      v-if="data && data.selectedTest && data.selectedTest.is_online_test"
                      label="Test Submission"
                      value="test_submission"
                      color="red"
                    ></v-radio>
                    <v-radio
                      label="Window Completion"
                      value="window_completion"
                      color="red"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <div class="select-center-blk">
                    <div v-for="center in selectedCenterList">
                      <div class="center-name-v">
                        {{ center.text }}
                      </div>

                      <div class="radio-center">
                        <div
                          class="check-cust center-check"
                          v-for="batch in center.batches"
                          :title="batch.text"
                        >
                          <v-checkbox
                            :disabled="
                              data.category && data.category === 'ONGOING'
                            "
                            v-model="batch.checked"
                            :label="batch.text"
                            dense
                            hide-details
                          ></v-checkbox>
                        </div>
                      </div>
                    </div>

                    <div v-if="!data.category || data.category !== 'ONGOING'">
                      <div v-if="showAddcenterButton" class="add-center-block">
                        <div
                          @click="showAddcenterButton = false"
                          class="primary-add-center"
                        >
                          <v-btn class="rounded-btn-add" color="primary">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <span class="center-add">Add Center</span>
                        </div>
                      </div>
                      <div
                        v-else-if="centers && centers.length > 0"
                        class="select-center"
                      >
                        <v-select
                          :items="centers"
                          v-model="selectedCenter"
                          no-data-text="No centers available"
                          label="Choose center"
                        ></v-select>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div v-if="selectedTest.shared_start_time">
         <b style="font-size: 14px;"> Shared test window:</b>
         {{ formatDate(selectedTest.shared_start_time) }} - {{ formatDate(selectedTest.shared_end_time) }}
        </div>
          <div class="right-align">
            <v-btn
              @click="scheduleTest"
              class="right-btn cust-btn"
              color="primary"
              >{{isRescheduling || (data && data.selectedTest && data.selectedTest.test_schedule_id) ?'Re-schedule':'Schedule'}}</v-btn
            >
          </div>
        </v-col>
      </v-row>
       <AlertBox :width="modalwidth" :onClose="onClosePopup" :component="cComponent" :status="openModelStatus" :data="alertBoxData" />
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import constants from "@/utils/constants.js";
import { mapActions, mapState } from "vuex";
export default {
  name: "ScheduleTest",
  props: ["onClose", "status", "data"],
  data() {
    return {
      startDate:
        this.data.selectedTest && this.data.selectedTest.scheduled_start
          ? moment(`${this.data.selectedTest.scheduled_start}`).format(
              "YYYY-MM-DD"
            )
          : null,
      endDate:
        this.data.selectedTest && this.data.selectedTest.scheduled_end
          ? moment(
              `${this.data.selectedTest.scheduled_end}`
            ).format("YYYY-MM-DD")
          : null,
      startTime:
        this.data.selectedTest && this.data.selectedTest.scheduled_start
          ? moment(`${this.data.selectedTest.scheduled_start}`).format("HH:mm")
          : null,
      endTime:
        this.data.selectedTest && this.data.selectedTest.scheduled_end
          ? moment(`${this.data.selectedTest.scheduled_end}`).format("HH:mm")
          : null,

      startDateMenu: false,
      endDateMenu: false,
      startTimeMenu: false,
      endTimeMenu: false,
      longTimeTest:this.data.selectedTest ? this.data.selectedTest.perpetual_test==1 ? true :false : false,
      tabChange:this.data.selectedTest ? this.data.selectedTest.is_required ==1: false,
      alertBoxData:{},
      modalwidth: "",
      cComponent: "",
      openModelStatus:false,
      isLongTimeTest:false,
      mode: this.data.selectedTest && this.data.selectedTest.visible ? this.data.selectedTest.visible : this.data.isOnlineTest ? null : constants.WINDOW_COMPLETION_VALUE,
      selectedTest: this.data.selectedTest,
      pickerDate: "Subscription is expired",
      testName: this.data.selectedTest.test_name,
      isRescheduling:
        this.data.selectedTest && this.data.selectedTest.schedule_id,
      loading: false,
      centers: [],
      batches: [],
      selectedCenter: null,
      selectedCenterList: [],
      showAddcenterButton: true,
      alreadySelectedBatches: [],
      rescheduleData: {
        startDateTime: null,
        endDateTime: null,
        maxUpdateTime: null,
      },
      allowed_end_date: null,
      allowed: null,
      shuffle:
        this.data.selectedTest && this.data.selectedTest.shuffle
          ? this.data.selectedTest.shuffle
          : false,
          isAitsTest: false,
          isPytTest: false,
    };
  },
  mounted() {
    console.log("TEtssssss -",this.data.selectedTest)
    if(this.data?.selectedTest && this.data?.selectedTest?.test_type == constants.TEST_TYPE.PREVIOUS_YEAR){
      this.isPytTest =true;
    }
    if(constants.AITS_INSTITUTE_ID.includes(this.data.selectedTest.institute_id)){
      this.isAitsTest =true;
    }
    console.log("isAitsTest:", this.isAitsTest);
    if(constants.LONG_TEST_INSTITUTE_IDS.includes(this.myInstitute.id)){
      this.isLongTimeTest=true;
    }
    this.requestGetCenters(this.getAlreadySelectedBatchDetails());
    if (this.isRescheduling) {
      this.cloneScheduleData();
    }
    if (localStorage.getItem("modules")) {
      this.modules = JSON.parse(localStorage.getItem("modules"));
      const slModule = this.modules.find(m => m.module_id === constants.MODULES.ST);
      const qpdModule = this.modules.find(m => m.module_id === constants.MODULES.QPD);
      
      if (slModule && slModule.expiry_date) {
        this.allowed_end_date = moment(slModule.expiry_date).format("YYYY-MM-DD");
      } else if (qpdModule && qpdModule.expiry_date) {
        this.allowed_end_date = moment(qpdModule.expiry_date).format("YYYY-MM-DD");
      }
      console.log("Modules from localStorage:", this.modules);
      if(this.modules.includes(constants.MODULES.SL)){
        this.isLongTimeTest=true;
      }
    }
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatchForScheduleTest: "centerAndBatchStore/getBatchForScheduleTest",
      schedule: "testStore/schedule",
      getInstituteDetails: "userStore/getInstituteDetails",
      getInstructions: "testStore/getInstructions",
    }),
    cloneScheduleData() {
      this.rescheduleData.startDateTime = moment(
        this.data.selectedTest.scheduled_start
      );
      this.rescheduleData.endDateTime = moment(
        this.data.selectedTest.scheduled_end
      );
      this.rescheduleData.maxUpdateTime = moment(
        this.data.selectedTest.scheduled_start
      ).subtract(15, "minutes");
    },

    getCentersFunction() {
      if (this.isCoordinator()) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    isCoordinator() {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user && user.role_id === constants.ROLES_ID.CO) {
        return true;
      }
      return false;
    },
    onClosePopup(data){
      this.openModelStatus=data.status;
      if(data && data.longTerm!=undefined){
        this.longTimeTest=data.longTerm;
      }
    },
    longTermTestWarning(){
      if(this.longTimeTest){
        this.cComponent =  "components/coordinator/Tests/CustomizedTests/LongTermTestPopup";
        this.alertBoxData.persistent = true;
        this.openModelStatus = true;
        this.modalwidth = '400px';
      }
    },

    requestGetCenters(alreadySelectedCenter) {
      this.centers = [];
      this.$root.showLoader = true;
      this[this.getCentersFunction()]()
        .then((response) => {
          this.$root.showLoader = false;
          this.allCenters = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
          this.centers = this.allCenters.filter((c) => {
            return alreadySelectedCenter.indexOf(c.value) === -1;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },

    /*fetchExpiryDate() {
      this.getInstituteDetails()
        .then((response) => {
          this.expiry_date = response.expiry_date;
          console.log(this.expiry_date);
        })
        .catch((err) => {
          console.log(err);
        });
      return this.expiry_date;
    },*/

    // requestGetCenters(alreadySelectedCenter) {
    //   this.getCenters({ orderBy: this.orderByForCenter })
    //     .then((response) => {
    //       this.loading = false;
    //       this.centers = response.map((x) => {
    //         let c = {};
    //         c.text = x.name;
    //         c.value = x.id;
    //         return c;
    //       });
    //       this.centers = this.centers.filter((c) => {
    //         return alreadySelectedCenter.indexOf(c.value) === -1;
    //       });
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //     });
    // },
    requestGetBatch(centerId) {
      let reqData = {
        orderBy: this.orderBy,
        center_id: [centerId],
        test_id: this.selectedTest.id,
        test_type: this.selectedTest.test_type,
      };

      this.getBatchForScheduleTest(reqData)
        .then((response) => {
          this.loading = false;
          let tmpCenter = this.centers.filter((x) => x.value === centerId);
          if (response && response.list && response.list.length) {
            let tmpBatch = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              c.checked = false;
              return c;
            });

            this.selectedCenterList.push({
              ...tmpCenter[0],
              batches: tmpBatch,
            });

            this.centers = this.centers.filter((x) => x.value !== centerId);
          } else {
            this.$toasted.error(
              `Batches not available for center ${tmpCenter[0].text}`,
              { icon: "info" }
            );
            this.centers = this.centers.filter((x) => x.value !== centerId);
            //   this.selectedCenterList.push({
            //         ...tmpCenter[0],
            //         batches: []

            //     })

            //     this.centers = this.centers.filter(x => x.value !== centerId)
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    validate(batchesIds) {
      let valid = true;
      let startDateTime = moment(`${this.startDate} ${this.startTime}`);
      let endDateTime = moment(`${this.endDate} ${this.endTime}`);
      let maxEndDate = moment(`${this.startDate} ${this.startTime}`).add(
        2,
        "day"
      );
      console.log(endDateTime.isAfter(maxEndDate));
      let currentTime = moment();
      let minStartTime = moment().add(15, "minutes");
      let minEndTime = moment(
        `${moment(`${this.endDate}`).format("YYYY-MM-DD")} ${this.endTime}`
      ).subtract(1, "minutes");
      if (!startDateTime.isValid()) {
        this.$toasted.error(`Please select start date and time`, {
          icon: "info",
        });
        valid = false;
      } else if (!endDateTime.isValid()) {
        this.$toasted.error(`Please select end date and time`, {
          icon: "info",
        });
        valid = false;
      } else if (
        startDateTime.isBefore(minStartTime) &&
        !startDateTime.isSame(this.rescheduleData.startDateTime)
      ) {
        this.$toasted.error(
          `Scheduled start time should be atleast 15 minute greater than the current time`,
          { icon: "info" }
        );
        valid = false;
      } else if (!this.testName || this.testName.trim().length == 0) {
        this.$toasted.error(`Please enter test name`, { icon: "info" });
        valid = false;
      } else if (
        startDateTime.isAfter(endDateTime) ||
        startDateTime.isSame(endDateTime)
      ) {
        this.$toasted.error(
          `Scheduled end date should be later than scheduled start date`,
          { icon: "info" }
        );
        valid = false;
      } else if (((!this.longTimeTest && endDateTime.isAfter(maxEndDate))||(this.longTimeTest && !endDateTime.isAfter(maxEndDate)))  && this.data.selectedTest.is_online_test) {
        this.$toasted.error(
          `Schedule end cannot be ${this.longTimeTest ? "less" : "greater"} than ${maxEndDate.format(
            "DD/MM/YYYY HH:mm"
          )}`,
          { icon: "info" }
        );
        valid = false;
      } else if (!this.mode && this.user.role_id !== this.roleIds.PA) {
        this.$toasted.error(`Please select option to Show solution`, {
          icon: "info",
        });
        valid = false;
      } else if (!batchesIds || batchesIds.length < 1 && this.user.role_id !== this.roleIds.PA) {
        this.$toasted.error(`Please select at least one batch`, {
          icon: "info",
        });
        valid = false;
      } else if (
        this.isRescheduling &&
        (this.data.category == "ONGOING" ||
          currentTime.isAfter(startDateTime)) &&
        this.rescheduleData.endDateTime.isAfter(endDateTime) && !(this.data.selectedTest.omr_pattern_id && !this.data.selectedTest.is_online_test )
      ) {
        this.$toasted.error(
          `End date and time cannot be decremented while test is Ongoing.`,
          { icon: "info" }
        );
        valid = false;
      } else if (
        this.isRescheduling &&
        currentTime.isAfter(minEndTime) &&
        endDateTime.isAfter(this.rescheduleData.endDateTime)
      ) {
        this.$toasted.error(
          `End date and time can only be incremented 1 minute before the scheduled end time.`,
          { icon: "info" }
        );
        valid = false;
      }
      return valid;
    },
    scheduleTest() {
      let batchesIds = [];
      if (this.selectedCenterList && this.selectedCenterList.length > 0) {
        this.selectedCenterList.map((center) => {
          batchesIds = [
            ...batchesIds,
            ...center.batches.filter((b) => b.checked).map((x) => x.value),
          ];
        });
      }
      if (this.validate(batchesIds)) {
        let startDateTime = moment(`${this.startDate} ${this.startTime}`);
        let endDateTime = moment(`${this.endDate} ${this.endTime}`);
        if(this.user.role_id == this.roleIds.PA){
          let batches = this.user.students.map(item => item.batch_id)
          .filter((value, index, self) => self.indexOf(value) === index);
          let reqData = {
          scheduled_start: startDateTime,
          scheduled_end: endDateTime,
          batches: batches,
          test_institute_id: this.data.selectedTest.test_institute_id,
          is_preview: false,
          perpetual_test: this.longTimeTest,
          is_tab_change: this.tabChange
        };
        this.getInstructions(reqData)
          .then((response) => {
            this.loading = false;
            this.onClose({ status: false, realodTest: true });
            this.$toasted.success(`Test scheduled successfully.`, {
              icon: "check_circle",
            });
          })
          .catch((err) => {
            this.loading = false;
          });
        }else{
          let reqData = {
          scheduled_start: startDateTime,
          scheduled_end: endDateTime,
          batches: batchesIds,
          test_id: this.selectedTest.id,
          visible: this.mode,
          alt_test_name: this.testName,
          shuffle: this.shuffle,
          schedule_id: this.selectedTest.schedule_id,
          perpetual_test: this.longTimeTest,
          is_tab_change: this.tabChange
        };
        this.schedule(reqData)
          .then((response) => {
            this.loading = false;
            this.onClose({ status: false, realodTest: true });
            this.$toasted.success(`Success\n${response.message}`, {
              icon: "check_circle",
            });
          })
          .catch((err) => {
            this.loading = false;
          });
        }
        
      }
    },
    resetValues() {
      if (this.data.selectedTest.schedule_id) {
        this.startDate =
          this.data.selectedTest && this.data.selectedTest.scheduled_start
            ? moment(`${this.data.selectedTest.scheduled_start}`).format(
                "YYYY-MM-DD"
              )
            : null;
        this.endDate =
          this.data.selectedTest && this.data.selectedTest.scheduled_end
            ? moment(`${this.data.selectedTest.scheduled_end}`).format(
                "YYYY-MM-DD"
              )
            : null;
        this.startTime =
          this.data.selectedTest && this.data.selectedTest.scheduled_start
            ? moment(`${this.data.selectedTest.scheduled_start}`).format(
                "HH:mm"
              )
            : null;
        this.endTime =
          this.data.selectedTest && this.data.selectedTest.scheduled_end
            ? moment(`${this.data.selectedTest.scheduled_end}`).format("HH:mm")
            : null;
        this.mode = this.data.selectedTest && this.data.selectedTest.visible ? this.data.selectedTest.visible : this.data.isOnlineTest ? null : constants.WINDOW_COMPLETION_VALUE;
        this.shuffle =
          this.data.selectedTest && this.data.selectedTest.shuffle
            ? this.data.selectedTest.shuffle
            : false;
      } else {
        this.startDate = null;
        this.endDate = null;
        this.startTime = null;
        this.endTime = null;
        this.mode = this.data.isOnlineTest ? null : constants.WINDOW_COMPLETION_VALUE;
        this.shuffle = false;
      }

      this.startDateMenu = false;
      this.endDateMenu = false;
      this.startTimeMenu = false;
      this.endTimeMenu = false;

      this.selectedTest = this.data.selectedTest;
      this.testName = this.data.selectedTest.test_name;
      this.loading = false;
      this.centers = [];
      this.batches = [];
      this.selectedCenter = null;
      this.selectedCenterList = [];
      this.showAddcenterButton = true;
      if(!this.isRescheduling){
        this.longTimeTest=false;
        this.tabChange=false;
      }
    },
    getAlreadySelectedBatchDetails() {
      let tmpCenter = [];
      let tmpBatches = [];
      if (this.data.selectedTest && this.data.selectedTest.batches) {
        this.alreadySelectedBatches = this.data.selectedTest.batches.map(
          (x) => {
            if (x.batchDetails) {
              tmpBatches.push(x.batchDetails.id);
              if (tmpCenter.indexOf(x.batchDetails.center_id) == -1) {
                tmpCenter.push(x.batchDetails.center_id);

                this.selectedCenterList.push({
                  text: x.batchDetails.centerDetails.name,
                  value: x.batchDetails.centerDetails.id,
                  batches: [],
                });
              }
            }
            return x.batch_id;
          }
        );

        if (tmpCenter && tmpCenter.length > 0) {
          let reqData = {
            orderBy: this.orderBy,
            center_id: tmpCenter,
            test_id: this.selectedTest.id,
            test_type: this.selectedTest.test_type,
          };
          this.getBatchForScheduleTest(reqData)
            .then((response) => {
              this.loading = false;

              if (response && response.list && response.list.length) {
                let tmpBatch = response.list.map((x) => {
                  let c = {};
                  c.text = x.name;
                  c.value = x.id;
                  c.center_id = x.center_id;
                  c.checked = tmpBatches.indexOf(x.id) !== -1;
                  return c;
                });

                response.list.map((x) => {
                  this.selectedCenterList.map((xx) => {
                    if (xx.value === x.center_id) {
                      xx.batches = tmpBatch.filter(
                        (b) => b.center_id === x.center_id
                      );
                    }
                  });
                });
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      }
      return tmpCenter;
    },
    formatDate(dateString) {
    if (!dateString) return ""; 
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  },
    computedDateFormattedMomentjs(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    allowedDates(val) {
      return this.allowed_end_date > val;
    },
  },
  watch: {
    status(val) {
      this.longTimeTest=this.data.selectedTest ? this.data.selectedTest.perpetual_test==1 ? true :false : false;
      this.tabChange=this.data.selectedTest ? this.data.selectedTest.is_required==1 ? true :false : false;
      if (val) {
        this.resetValues();
        this.requestGetCenters(this.getAlreadySelectedBatchDetails());
        if (this.isRescheduling) {
          this.cloneScheduleData();
        }
      }
    },
    selectedCenter(val) {
      if (val) {
        this.showAddcenterButton = true;
        this.requestGetBatch(val);
      }
    },
  },
  computed: {
    disableStartDateTime() {
      if (this.data.category && this.data.category === "ONGOING") {
        return true;
      }
      let currentTime = moment();

      if (
        this.rescheduleData.maxUpdateTime &&
        this.rescheduleData.maxUpdateTime < currentTime
      ) {
        return true;
      }
      return false;
    },
    ...mapState("userStore", ["user","myInstitute"]),
  },
};
</script>
